import { Grid } from '@mui/material'
import { FormikContextType, useFormikContext } from 'formik'
import { useCallback, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { OnboardingFormContext } from '../../../providers/contexts/OnboardingForm'
import { MESSAGES } from '../../../utils/constants'
import useTimedState from '../../../utils/hooks/useTimedState'
import { OnboardingStepsFormType } from '../../../utils/types/auth'
import OTPInput from '../../otp-input'

import { ReactComponent as Help } from '../../../assets/images/icons/Help.svg'
import { useSignupNavigate } from '../_hooks'
import './onboarding-step3.scss'

const OnboardingStepTwo = () => {
    const {
        values,
        touched,
        errors,
        setFieldValue,
        setTouched,
    }: FormikContextType<OnboardingStepsFormType> = useFormikContext()
    const { t } = useTranslation()

    const [resendSuccess, setResendSuccess] = useTimedState(false)
    const {
        handleResendOtp,
        submittedOtp,
        setIsOtpSameAsLast,
        isOtpSameAsLast,
        otpError,
    } = useContext(OnboardingFormContext)

    const onChange = useCallback(
        (value: string) => {
            setFieldValue('otp', value)
            setIsOtpSameAsLast(submittedOtp === value)
        },
        [setFieldValue, setIsOtpSameAsLast, submittedOtp]
    )

    const resendOtp = async () => {
        try {
            await handleResendOtp(
                values.emailAddress ?? '',
                values.countrySelected?.toLowerCase() ?? '',
                true
            )
            setResendSuccess(true)
        } catch (error) {
            // handle error
        }
    }
    useSignupNavigate()

    useEffect(() => {
        setFieldValue('otp', '')
        setTouched({}, false)
    }, [setFieldValue, setTouched])

    return (
        <div className="onboarding-step3 signup-forms">
            <OTPInput
                name="otp"
                value={values.otp ?? ''}
                valueLength={6}
                touched={touched.otp}
                error={
                    isOtpSameAsLast
                        ? t(otpError) ?? ''
                        : t(errors?.otp ?? '') ?? ''
                }
                onChange={onChange}
            />

            <Grid className="email-support">
                <p className="verification-code-message">
                    {t(
                        'code_verification_page.code_verification_sent_to_email'
                    )}
                </p>
                <p>
                    {t('code_verification_page.code_verification_resend_text')}{' '}
                    <span>
                        {t(
                            'code_verification_page.code_verification_check_spam'
                        )}
                    </span>{' '}
                    <span>{t('common_elements.or')}</span>{' '}
                    <span className="link resend-otp-link" onClick={resendOtp}>
                        {t(
                            'code_verification_page.code_verification_resend_link'
                        ).toLocaleLowerCase()}
                    </span>
                </p>
                {resendSuccess && (
                    <p className="otp-success-message center-text">
                        {t(MESSAGES.info.resendOtp)}
                    </p>
                )}

                <a
                    href="mailto:orders@hydrafacial.com"
                    className="support-link"
                >
                    <Help />{' '}
                    <span className="link">
                        {t(
                            'code_verification_page.code_verification_support_email'
                        )}
                    </span>
                </a>
            </Grid>
        </div>
    )
}

export default OnboardingStepTwo
